<template>
  <div class="login-page " v-show="ishowLoginPage">
    <div class="login-wrap h100vh  pr">
      <header>
        <img src="~assets/img/cupshe_logo.png" class="w100p" alt="" srcset="" />
      </header>
      <div class="login-wrap_left">
        <h1 class="weclome">欢迎使用</h1>
        <h3 class="cupshe-name">CUPSHE统一门户系统</h3>
        <p class="env" v-if="envDesc">({{ envDesc }})</p>
        <p class="desc" v-else>高效协作/轻松管理</p>
      </div>
      <div class="login-wrap_right">
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane :key="3" tab="飞书扫码">
            <div id="login_container_feishu" class="df jcc"></div>
          </a-tab-pane>
          <a-tab-pane :key="1" tab="钉钉扫码">
            <div id="login_container" class="df jcc"></div>
          </a-tab-pane>
          <a-tab-pane :key="2" tab="账号登录">
            <LoginPassword></LoginPassword>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, ref, toRefs } from 'vue'
import { useFeishuLogin, useDingtalkLogin } from './hook'
import LoginPassword from './components/password.vue'
import { useStore } from 'vuex'

export default {
  components: {
    LoginPassword
  },
  setup() {
    const state = reactive({
      activeKey: 3,
      ishowLoginPage: false
    })

    // 创建store对象
    const store = useStore()

    useDingtalkLogin(state, store)
    const { feishuRequestAuthCode } = useFeishuLogin(state, store)

    onMounted(function() {
      try {
        if (window.h5sdk && window.h5sdk.ready) {
          state.ishowLoginPage = false
          feishuRequestAuthCode()
        } else {
          state.ishowLoginPage = true
        }
      } catch (error) {
        console.log(error)
      }
    })

    return {
      envDesc: process.env.VUE_APP_ENV_DESC,
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
:deep input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
}
.login {
  &-page {
    position: relative;
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background: url('~assets/img/havaii.png') center/cover no-repeat;
    background-size: 150% 120%;
  }
  &-wrap {
    width: 1440px;
    display: flex;
    align-items: center;
    padding: 0 162px;
    header {
      position: absolute;
      top: 60px;
      left: 80px;
      width: 240px;
    }
    &_left {
      & > * {
        color: #ffffff;
      }

      h1 {
        font-size: 64px;
        font-weight: 800;
        line-height: 80px;
        letter-spacing: 8px;
      }
      h3 {
        font-size: 44px;
        font-weight: bold;
        line-height: 55px;
        letter-spacing: 4px;
        margin: 8px 165px 24px 0;
      }
      .env {
        font-size: 32px;
        font-weight: 300;
        line-height: 40px;
        letter-spacing: 3px;
      }
      .desc {
        font-size: 24px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #ffffff;
        line-height: 33px;
        letter-spacing: 20px;
      }
    }
    &_right {
      width: 440px;
      height: 457px;
      background: #ffffff;
      box-shadow: 0px 4px 9px 0px rgba(0, 42, 68, 0.4);
      :deep .portal-ant-tabs-nav .portal-ant-tabs-tab {
        padding: 24px 16px 24px 16px;
      }
      :deep .portal-ant-tabs-nav-scroll {
        display: flex;
        justify-content: center;
      }
      :deep .portal-ant-tabs-nav {
        /* margin-left: 25%; */
        .portal-ant-tabs-tab {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 33px;
        }
        .portal-ant-tabs-ink-bar {
          width: 120px;
          height: 4px;
          background: #1ea0f0;
        }
      }
    }
  }
}
</style>
